module.exports = __webpack_public_path__ + "img/icon_sec3_03.7c5d26cc.png";